import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation sendCustomerTokenLink($activityId: String, $customerId: ID){
 sendCustomerTokenLink(activityId: $activityId, customerId: $customerId)
}`;

function getCustomerTokenLink({ activityId, customerId }) {
  return apollo.client.mutate({
    variables: {
      activityId,
      customerId,
    },
    mutation,
  })
    .then((res) => res.data.sendCustomerTokenLink);
}

export default getCustomerTokenLink;
